import { render, staticRenderFns } from "./leadpiechart.vue?vue&type=template&id=54e5ac6e"
import script from "./leadpiechart.vue?vue&type=script&lang=js"
export * from "./leadpiechart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports